import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
export default {
  __name: 'MonitorStatus',
  props: {
    monitorState: {
      type: Number
    },
    examineState: {
      type: Number,
      default: -1
    }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      const _component_el_tag = _resolveComponent("el-tag");
      return _openBlock(), _createElementBlock("span", null, [__props.monitorState === 0 ? (_openBlock(), _createBlock(_component_el_tag, {
        key: 0,
        type: "success",
        effect: "dark"
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode("已监测", -1)]))]),
        _: 1
      })) : __props.monitorState === -1 ? (_openBlock(), _createBlock(_component_el_tag, {
        key: 1,
        type: "danger",
        effect: "dark"
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("暂无", -1)]))]),
        _: 1
      })) : __props.monitorState === 1 || __props.monitorState === 4 ? (_openBlock(), _createBlock(_component_el_tag, {
        key: 2,
        type: "warning",
        effect: "dark"
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode("监测未认领", -1)]))]),
        _: 1
      })) : __props.monitorState === 2 ? (_openBlock(), _createBlock(_component_el_tag, {
        key: 3,
        effect: "dark"
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode("监测已认领", -1)]))]),
        _: 1
      })) : __props.monitorState === 3 ? (_openBlock(), _createBlock(_component_el_tag, {
        key: 4,
        type: "info",
        effect: "dark"
      }, {
        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("待审核", -1)]))]),
        _: 1
      })) : __props.monitorState === 7 && __props.examineState === 3 ? (_openBlock(), _createBlock(_component_el_tag, {
        key: 5,
        type: "warning"
      }, {
        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("投放待认领", -1)]))]),
        _: 1
      })) : __props.monitorState === 7 && __props.examineState === -1 ? (_openBlock(), _createBlock(_component_el_tag, {
        key: 6,
        type: "warning",
        effect: "dark"
      }, {
        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode("待审核投放", -1)]))]),
        _: 1
      })) : __props.monitorState === 7 && __props.examineState === 2 ? (_openBlock(), _createBlock(_component_el_tag, {
        key: 7,
        type: "warning",
        effect: "dark"
      }, {
        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode("待审核", -1)]))]),
        _: 1
      })) : __props.monitorState === 7 && __props.examineState === 1 ? (_openBlock(), _createBlock(_component_el_tag, {
        key: 8,
        type: "danger",
        effect: "dark"
      }, {
        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode("未通过", -1)]))]),
        _: 1
      })) : __props.monitorState === 7 && __props.examineState === 0 ? (_openBlock(), _createBlock(_component_el_tag, {
        key: 9,
        type: "success",
        effect: "dark"
      }, {
        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode("已通过", -1)]))]),
        _: 1
      })) : __props.monitorState === 7 && __props.examineState === 5 ? (_openBlock(), _createBlock(_component_el_tag, {
        key: 10,
        type: "success",
        effect: "dark"
      }, {
        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode("已提交", -1)]))]),
        _: 1
      })) : __props.monitorState === 7 && __props.examineState !== 3 ? (_openBlock(), _createBlock(_component_el_tag, {
        key: 11,
        type: "success"
      }, {
        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createTextVNode("投放已认领", -1)]))]),
        _: 1
      })) : __props.monitorState === 5 ? (_openBlock(), _createBlock(_component_el_tag, {
        key: 12,
        type: "danger",
        effect: "dark"
      }, {
        default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode("审核不通过", -1)]))]),
        _: 1
      })) : __props.monitorState === 13 ? (_openBlock(), _createBlock(_component_el_tag, {
        key: 13,
        effect: "dark"
      }, {
        default: _withCtx(() => [...(_cache[13] || (_cache[13] = [_createTextVNode("待比对", -1)]))]),
        _: 1
      })) : __props.monitorState === 6 ? (_openBlock(), _createBlock(_component_el_tag, {
        key: 14,
        effect: "dark"
      }, {
        default: _withCtx(() => [...(_cache[14] || (_cache[14] = [_createTextVNode("比对中", -1)]))]),
        _: 1
      })) : __props.monitorState === 9 ? (_openBlock(), _createBlock(_component_el_tag, {
        key: 15,
        type: "success"
      }, {
        default: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createTextVNode("任务结束", -1)]))]),
        _: 1
      })) : __props.monitorState === 10 ? (_openBlock(), _createBlock(_component_el_tag, {
        key: 16,
        type: "danger"
      }, {
        default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode("审核复核中", -1)]))]),
        _: 1
      })) : __props.monitorState === 11 ? (_openBlock(), _createBlock(_component_el_tag, {
        key: 17,
        type: "danger"
      }, {
        default: _withCtx(() => [...(_cache[17] || (_cache[17] = [_createTextVNode("复核未通过", -1)]))]),
        _: 1
      })) : __props.monitorState === 12 ? (_openBlock(), _createBlock(_component_el_tag, {
        key: 18,
        type: "danger"
      }, {
        default: _withCtx(() => [...(_cache[18] || (_cache[18] = [_createTextVNode("复核通过", -1)]))]),
        _: 1
      })) : (_openBlock(), _createBlock(_component_el_tag, {
        key: 19,
        type: "info"
      }, {
        default: _withCtx(() => [...(_cache[19] || (_cache[19] = [_createTextVNode("未知状态", -1)]))]),
        _: 1
      }))]);
    };
  }
};